import type { JsxStyleProps } from '@chakra-ui/react';
import { chakra } from '@chakra-ui/react';
import type { ReactNode } from 'react';
import { codesToEmoji } from '../../utils';

export interface OriginalRenderProps extends JsxStyleProps {
  size?: JsxStyleProps['fontSize'];
  codesList?: string[][];
  children?: ReactNode;
}

export const OriginalRender = memo(function OriginalRender({
  size = '1em',
  codesList,
  children,
  ...props
}: OriginalRenderProps) {
  const children_ = useMemo(() => {
    return (
      children ??
      codesList?.map((codes) => {
        return codesToEmoji(codes);
      })
    );
  }, [children, codesList]);

  return (
    <chakra.span fontSize={size} {...props}>
      {children_}
    </chakra.span>
  );
});
